









































import { Component, Prop, Vue } from 'vue-property-decorator';
import {UserProfile} from "../../../../../api/models/UserProfile";
import {ProfileField} from "../../../../../types/ProfileField";
import PhotoComponent from "../../../../../share/settings/photo/Photo.vue";
import ProfileFieldInput from "./ProfileFieldInput.vue";

@Component({
    name: 'InfoPart',
    components: { PhotoComponent, ProfileFieldInput }
})
export default class InfoPart extends Vue {
    @Prop({required: true}) profile: UserProfile;
    @Prop({required: true}) validationMessages: Record<string, string>;
    @Prop({required: true}) fields: Array<ProfileField>;
    @Prop({default: () => ({})}) termsOfUse: any;
    @Prop() buttonText: string | undefined;

    caption(field: ProfileField) {
        const language = this.$store.state.session?.language ?? 'en';

        return field && field.title && field.title[language]
            ? field.title[language]
            : this.$t('settings.' + field.name.toLowerCase());
    }

    get termsOfUseShow() {
        return this.termsOfUse?.show
    }

    get termsOfUseUrl() {
        return this.termsOfUse?.url
    }

    get filteredFields() {
        return this.fields.filter((field) => field.type !== 'tag')

    }

    get privateFields() {
        return this.filteredFields.filter((field) => field.isPrivate);
    }

    get publicFields() {
        return this.filteredFields.filter((field) => !field.isPrivate);
    }

}
